<template>
  <AppDialog
    title="Update individual overrides?"
    append-to-body
    show
    @close="closeDialog"
  >
    <div class="dialog-p">{{ overrideMessage }} Would you like to update them to match the new default?</div>

    <div class="d-flex justify-space-between flex-column flex-sm-row mt-40 gap-20">
      <AppButton
        type="default"
        @click="closeDialog"
      >
        Cancel
      </AppButton>

      <div class="d-flex flex-column flex-sm-row gap-20">
        <button
          class="btn btn-danger"
          type="submit"
          @click="onFormSubmit('update')"
        >
          Yes, update {{ overrideButtonMessage }}
        </button>

        <button
          class="btn btn-primary"
          type="submit"
          @click="onFormSubmit('keep')"
        >
          No, keep {{ overrideButtonMessage }}
        </button>
      </div>
    </div>
  </AppDialog>
</template>
<script>
import { pluralize } from '~/utils/string_utils';

export default {
  name: 'MemberUpdateOverridesDialog',
  props: {
    overridesCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    overrideMessage() {
      if (this.overridesCount === 1) {
        return 'There is currently (1) member with an individual override.';
      }

      return `There are currently (${this.overridesCount}) members with individual overrides.`;
    },
    overrideButtonMessage() {
      return `${this.overridesCount} ${pluralize(this.overridesCount, 'override')}`;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    onFormSubmit(val) {
      this.$emit('close-confirmed', val);
    },
  },
};
</script>
